import { ChronoUnit, Duration } from "@js-joda/core";

export const TIME_UNITS = [
  {
    value: ChronoUnit.SECONDS,
    label: "Seconds",
  },
  {
    value: ChronoUnit.MINUTES,
    label: "Minutes",
  },
  {
    value: ChronoUnit.HOURS,
    label: "Hours",
  },
  {
    value: ChronoUnit.DAYS,
    label: "Days",
  },
  {
    value: ChronoUnit.WEEKS,
    label: "Weeks",
  },
  {
    value: ChronoUnit.MONTHS,
    label: "Months",
  },
  {
    value: ChronoUnit.YEARS,
    label: "Years",
  },
];

const CHRONO_TO_DAYS = [ChronoUnit.SECONDS, ChronoUnit.MINUTES, ChronoUnit.HOURS, ChronoUnit.DAYS];

export const TIME_UNITS_TO_DAYS = TIME_UNITS.filter(unit => CHRONO_TO_DAYS.includes(unit.value));

export const durationMinUnit = (duration: Duration): ChronoUnit => {
  if (duration.toDays() > 0) {
    return ChronoUnit.DAYS;
  }
  if (duration.toHours() > 0) {
    return ChronoUnit.HOURS;
  }
  if (duration.toMinutes() > 0) {
    return ChronoUnit.MINUTES;
  }
  return ChronoUnit.SECONDS;
};

export const getValueForUnit = (duration: Duration, unit: ChronoUnit): number => {
  if (unit === ChronoUnit.DAYS) {
    return duration.toDays();
  }
  if (unit === ChronoUnit.HOURS) {
    return duration.toHours();
  }
  if (unit === ChronoUnit.MINUTES) {
    return duration.toMinutes();
  }
  return duration.seconds();
};

export type TimeOptionKeys = keyof typeof TimeOptions;

export const TimeOptions = {
  DAYS: {
    value: "Daily",
    duration: Duration.ofDays(1),
    timeFormat: "MM-dd",
    name: "DAYS"
  },
  HOURS: {
    value: "Hourly",
    duration: Duration.ofHours(1),
    timeFormat: "HH:mm",
    name: "HOURS"
  },
};
